import { useEffect } from 'react';
import { useCallDrawerStore } from '../../stores/call-drawer-store';
import { CallDetailPanel } from './CallDetailPanel';

/**
 * Side-drawer voor gespreksdetail (opname, samenvatting, transcript). Globaal
 * gemount in AppLayout, zodat elke page `useCallDrawerStore.open(callId)` kan
 * aanroepen — net als de order-detail drawer. Schuift in vanaf rechts i.p.v.
 * onder een lange lijst.
 */
export function CallDetailDrawerPanel() {
  const openCallId = useCallDrawerStore((s) => s.openCallId);
  const close = useCallDrawerStore((s) => s.close);

  useEffect(() => {
    if (!openCallId) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      const t = e.target as HTMLElement | null;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT')) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      close();
    };
    window.addEventListener('keydown', handler, true);
    return () => window.removeEventListener('keydown', handler, true);
  }, [openCallId, close]);

  if (!openCallId) return null;

  return (
    <>
      <div className="fixed inset-0 bg-slate-900/30 z-[55]" onClick={close} aria-hidden />
      <aside
        className="fixed top-0 right-0 h-full w-full max-w-2xl bg-white shadow-2xl z-[60] flex flex-col"
        role="dialog"
        aria-modal="true"
        aria-label="Gespreksdetail"
      >
        <CallDetailPanel key={openCallId} callId={openCallId} onClose={close} variant="drawer" />
      </aside>
    </>
  );
}
